import React from "react";
import { Link } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { Path } from "../Path";
import { ConventionLogoSquare } from "../events/ConventionLogo";
import { formatConventionDateV2, formatDateWithTimezone, formatLocation } from "@seabrookstudios/pitch2table-core";
import Box from "@mui/material/Box";

/**
 * Renders a public event list entry.
 * @param {{ item: import("@seabrookstudios/pitch2table-core").CalendarEvent }} props
 */
export const PublicEventListEntry = ({ item }) => {
  const primary = item.name;
  const secondary = `${formatConventionDateV2(item)} • ${formatLocation(item)}`;

  return (
    <ListItemButton
      alignItems="flex-start"
      component={item.slug ? Link : 'div'}
      to={item.slug ? Path.public().event(item.slug) : undefined}
    >
      <ListItemAvatar>
        <ConventionLogoSquare convention={item} width={48} height={48} />
      </ListItemAvatar>
      <ListItemText primary={primary} secondary={secondary} />
      {item.type === "Competition" && (
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <ListItemText
            primary="Submissions Close"
            secondary={formatDateWithTimezone(item.submissionDate, item.timezone || "UTC")}
          />
        </Box>
      )}
    </ListItemButton>
  );
};
